/**
  * All rights Reserved, Designed By www.feidai.com
  * @Title:  financial.ts
  * @Package :
  * @author:飞算科技
  * @date:   2022/7/6 14:13
  * @version V1.0
  * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
  * @Belong To: 飞算科技
  * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
  */

/* 第三方服务-金融服务模块 */

 const financialRouter = [
   {
     path: '/financialServices',
     name: 'FinancialServices',
     component: () =>
             import(/* webpackChunkName: "financial" */ '@/views/financial/index.vue'),
     meta: {
       title: '金融服务',
       deepth: 1,
       permission: true
     },
   },
   {
     path: '/orderFinance',
     name: 'OrderFinance',
     component: () =>
             import(/* webpackChunkName: "financial" */ '@/views/financial/OrderFinance.vue'),
     meta: {
       title: '金融服务',
       deepth: 1,
       permission: true
     },
   },
  {
    path: '/applyQuota',
    name: 'ApplyQuota',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/ApplyQuota.vue'),
    meta: {
      title: '去出额',
      deepth: 2
    },
  },
  {
    path: '/authorize',
    name: 'Authorize',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/authorize.vue'),
    meta: {
      title: '个人信息使用授权书',
      deepth: 3
    },
  },
  {
    path: '/orderSelect',
    name: 'OrderSelect',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/OrderSelect.vue'),
    meta: {
      title: '订单选择',
      deepth: 4
    },
  },
  {
    path: '/description',
    name: 'description',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/description.vue'),
    meta: {
      title: '免息权益说明',
      deepth: 4
    },
  },
  {
    path: '/shopOrderDetail',
    name: 'ShopOrderDetail',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/ShopOrderDetail.vue'),
    meta: {
      title: '订货单详情',
      keepAlive: true,
      deepth: 4,
      permission: true
    },
  },
  {
    path: '/returnMerchBill',
    name: 'ReturnMerchBill',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/ReturnMerchBill.vue'),
    meta: {
      title: '商品套餐清单',
      deepth: 6
    },
  },
  {
    path: '/choosePackage',
    name: 'ChoosePackage',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/ChoosePackage.vue'),
    meta: {
      title: '选择商品套餐',
      deepth: 5
    },
  },
  {
    path: '/submitReturnOrder',
    name: 'SubmitReturnOrder',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/SubmitReturnOrder.vue'),
    meta: {
      title: '提交退货单',
      keepAlive: true,
      deepth: 6
    },
  },
  {
    path: '/returnMerchBill',
    name: 'ReturnMerchBill',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/ReturnMerchBill.vue'),
    meta: {
      title: '商品套餐清单',
      deepth: 6
    },
  },
  {
    path: '/submitReturnSuccess',
    name: 'SubmitReturnSuccess',
    component: () =>
            import(/* webpackChunkName: "financial" */ '@/views/financial/SubmitReturnSuccess.vue'),
    meta: {
      title: '退单提交成功',
      deepth: 1
    },
  },
 ]

export default financialRouter
